import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { DevelopmentStatusEntity } from './developmentpost.entity';
import { developmentResponseModel, developmentstatusResponseModel } from './dto/developmentpost-response-module';
import { developmentpoststatusupdateDTO, developmentStatusDTO, GetdevelopmentbypoststatusDTO } from './dto/developmentpost.dto';

@Injectable()
export class DevelopmentpostService {

    constructor(
      
        @InjectRepository(DevelopmentStatusEntity)
        private developmentpostRepository: Repository<DevelopmentStatusEntity>
    ) {}

    
     async updatedevelopmentstatus(queryParams, developmentpoststatusupdateDTO: developmentpoststatusupdateDTO, request:Request): Promise<developmentResponseModel> {
      const response = new developmentResponseModel();
      
      try {
          if(queryParams.apiVersion == 1) {
              const updatePostType = await this.developmentpostRepository.update({postId:developmentpoststatusupdateDTO.postId}, developmentpoststatusupdateDTO);
              const updatedData = await this.developmentpostRepository.findOne({
                relations:['post'],
                where:{postId:developmentpoststatusupdateDTO.postId}
            });
              if(updatePostType) {
                  response.status = true;
                  response.data = updatedData;
                  response.statusCode = 50000;
                  response.internalMessage = 'development post status updated successfully';
                  response.intlCode = 11108;
              } else {
                  throw new ErrorResponse(99998, 'development post status Update Failed')
              }
          } else {
            const updatePostType = await this.developmentpostRepository.update({postId:developmentpoststatusupdateDTO.postId}, developmentpoststatusupdateDTO);
              const updatedData = await this.developmentpostRepository.findOne({
              relations:['post'],
              where:{postId:developmentpoststatusupdateDTO.postId}
          });
            if(updatePostType) {
                response.status = true;
                response.data = updatedData;
                response.statusCode = 50000;
                response.internalMessage = 'development post status updated successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'development post status Update Failed')
            }
          }
          return response;
      } catch (error) {
          throw error;
      }
    
      
    }

    
}
